<template>
	<a href="#!" class="btn btn-table btn-sm" v-tooltip="'Editar'" data-toggle="tooltip" data-placement="bottom" v-on:click.prevent="editClient(codigoCliente)">
        <i class="fa fa-edit" aria-hidden="true"></i>
    </a>
</template>
<script>
	export default {
		props: {
			codigo: {
	  			required: true
			}
		},

		methods: {
			editClient(id){
				vm.$refs.foo.edit(id);
			}
		},

		computed: {
			codigoCliente: function () {
				return this.codigo;
			}
		}
	}
</script>